import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class Gainers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gainerList: [],
        };
    }

    componentDidMount() {
        ApiService.getGainers()
            .then(result => {
                console.log('Gainers', result);
                let filteredData = [];
                for (var i = 0; i < 10; i++) {
                    filteredData.push(result[i]);
                }
                this.setState({ gainerList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRowGainer(listValue) {
        if (listValue !== undefined && listValue.ticker !== undefined) {
            let url = '/chart/' + listValue.ticker;
            return (
                <tr style={{ color: 'green' }} key={listValue.ticker}>
                    <td style={{ color: 'green' }}><Link to={url}>{listValue.ticker}</Link></td>
                    <td>{parseFloat(listValue.price).toFixed(2)}</td>
                    <td>{parseFloat(listValue.changesPercentage).toFixed(2)}%</td>
                    <td ><Link style={{ color: 'green' }} to={'/stocks/gainers'}>Top Gainers</Link></td>
                </tr>
            )
        }
    }

    render() {
        let gainerRow;
        if (this.state.gainerList === undefined || this.state.gainerList.length <= 0) {
            gainerRow = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            gainerRow = this.state.gainerList.map(this.renderRowGainer.bind(this));
        }

        return (
            <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Ticker</th>
                        <th>Last</th>
                        <th>Change</th>
                        <th><Link to={'/stocks/gainers'}>Top Gainers</Link></th>
                    </tr>
                </thead>
                <tbody>
                    {gainerRow}
                </tbody>
            </Table>
        );
    }
}

export default Gainers;
